import './RSODynamicButtonGroup.scss'

export let RSODynamicButtonGroup = ({ buttons, setter, getter, color, myStyle, setter1 }) => {
  return (
    <div className={`RSODynamicButtonGroup RSODynamicButtonGroup--${color}`} style={myStyle}>
      {buttons?.filter(Boolean).map(item => (
        <button
          key={item?.title}
          className={`RSODynamicButtonGroup-btn ${color ? `RSODynamicButtonGroup-btn--${color}` : ''} ${getter === item?.title ? 'selected' : 'unselected'}`}
          onClick={() => (setter(item?.title))}>
          {item?.title}
        </button>
      ))}
    </div>
  );
}
